exat_startAttribute ();

function exat_startAttribute () {
  if(exat_page=='cart' || exat_page=='register'){
        pifyJquery (document).ready (function () {
          pifyJquery(".exat-attribute").parent("form").validate();
          pifyJquery(".exat-form").validate();
          pifyJquery("#RegisterForm").validate();
          
          pifyJquery ('.exat-datepicker').datepicker ({
            dateFormat: 'yy/mm/dd',
            changeMonth: true,
            changeYear: true,
            yearRange: 'c-70:c+10',
          });
          
          pifyJquery('.exat-attribute').find("input").val("");
          pifyJquery('.exat-attribute').find("textarea").val("");
          pifyJquery('.exat-attribute').find("select").val("");
        });
  }
  else if (exat_page == 'account') {
    pifyJquery (document).ready (function () {
      var $wrap = pifyJquery ('#exat_account_attribute_wrap');
      var shop = $wrap.attr ('shop');
      var customerId = $wrap.attr ('customer-id');
      var header = '<h4>Additional</h4>';
      var render = '<ul>{items}</ul>';

      // ajax get data
      pifyJquery.ajax ({
        url: 'https://customized-attribute.pifyapp.com/api/customer/note/list?shop=' +
          shop +
          '&customerId=' +
          customerId,
        dataType: 'json',
        success: function (data) {
          console.log (data);
          var items = '';
          var item = '<li>{itemContent}</li>';
          if (data != null && data.length > 0) {
            for (var index = 0; index < data.length; index++) {
              items =
                items +
                item.replace (
                  '{itemContent}',
                  data[index].key + ' : ' + data[index].value
                );
            }
            render = render.replace ('{items}', items);
            $wrap.html (header + '\n' + render);
          }
        },
      });
    });
  }

  
}


function exat_fun_checkbox(source,target){
  var targetValue="";
  var checkboxs=document.getElementsByName(source);
  for(var i=0;i<checkboxs.length;i++)
  {
    if(checkboxs[i].checked){
      targetValue=targetValue+checkboxs[i].value+',';
    }
  }
  if(targetValue.length>0){
    targetValue=targetValue.substr(0,targetValue.length-1);
  }

  document.getElementById(target).value=targetValue;
}
